import React from "react";

/**
 * Small version badge (v.01, v.02...) shown next to offer numbers.
 * By default only renders when version > 1.
 */
export default function VersionBadge({ version = 1, alwaysShow = false, className = "" }) {
  const v = Number(version) || 1;
  if (!alwaysShow && v <= 1) return null;
  const label = `v.${String(v).padStart(2, "0")}`;
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-mono font-semibold uppercase tracking-wider border border-[#FACC15] bg-[#FEF9C3] text-[#854D0E] leading-none ${className}`}
      title={`Versione ${v}`}
      data-testid="version-badge"
    >
      {label}
    </span>
  );
}
